export default {
  path: '/change_logs',
  name: 'change_logs',
  component: () => import('../components/changelog/Layout'),
  redirect: { name: 'ChangeLogList' },
  meta: {
    breadcrumb: 'version.changelog.changelogs',
  },
  children: [
    {
      name: 'ChangeLogList',
      path: '',
      component: () => import('../views/changelog/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ChangeLogCreate',
      path: 'new',
      component: () => import('../views/changelog/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ChangeLogUpdate',
      path: ':id/edit',
      component: () => import('../views/changelog/Update'),
      meta: {
        breadcrumb: 'version.changelog.changelog',
      },
    },
    {
      name: 'ChangeLogShow',
      path: ':id',
      component: () => import('../views/changelog/Show'),
      meta: {
        breadcrumb: 'version.changelog.changelog',
      },
    },
    {
      name: 'Link',
      path: ':parent',
      component: () => import('../components/link/Layout'),
      meta: {
        breadcrumb: 'version.link.links',
      },
      children: [
        {
          name: 'LinkShow',
          path: ':id',
          component: () => import('../views/link/Show'),
          meta: {
            breadcrumb: 'version.link.link',
          },
        },
        {
          name: 'LinkUpdate',
          path: ':id/edit',
          component: () => import('../views/link/Update'),
          meta: {
            breadcrumb: 'version.link.link',
          },
        },
        {
          name: 'LinkCreate',
          path: 'new',
          component: () => import('../views/link/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
